import React from "react";
import { useTranslation } from "react-i18next";
import CenterModal from "../../../mobilecomponent/CenterModal";

const PhotoAlertModal = ({ setPhotoAlert }) => {
  const { t } = useTranslation();
  const closebasic = "/images/mo/closebasic.svg";

  return (
    <CenterModal setPhotoAlert={setPhotoAlert}>
      <img
        src={closebasic}
        alt={closebasic}
        className="absolute top-0 right-0 cursor-pointer"
        onClick={() => {
          setPhotoAlert(false);
        }}
      />
      <span className="pt-[16px]">{t('PhotoAlertModal_max_photos', '사진은 5장까지만 첨부가능합니다.')}</span>
    </CenterModal>
  );
};

export default PhotoAlertModal;
